import dynamic from 'next/dynamic';

export default {
  // Navigation
  BreadCrumbs: dynamic(() => import('@eneco/sitecore-components-content/Breadcrumbs/Breadcrumbs')),
  FooterMenu: dynamic(() => import('@eneco/sitecore-components-content/Footer/FooterMenu')),
  Footer: dynamic(() => import('@eneco/sitecore-components-content/Footer/Footer')),
  LanguageSelector: dynamic(() => import('@eneco/sitecore-components-content/LanguageSelector/LanguageSelector')),
  Logo: dynamic(() => import('@eneco/sitecore-components-eneco/ImageLink/ImageLink')),
  MainNavigation: dynamic(() => import('@apps/header-shared-multilabel/Header')),
  MegaMenu: dynamic(() => import('@eneco/sitecore-components-content/MegaMenu/MegaMenu')),
  MegaMenuV2: dynamic(() => import('@eneco/sitecore-components-content/MegaMenuV2/MegaMenuV2')),
  MegaMenuDivision: dynamic(() => import('@eneco/sitecore-components-content/MegaMenuDivision/MegaMenuDivision')),
  MessageBar: dynamic(() => import('@eneco/sitecore-components-content/MessageBar/MessageBar')),
  NotificationsBar: dynamic(() => import('@eneco/sitecore-components-content/NotificationsBar/NotificationsBar')),
  SubFooterMenu: dynamic(() => import('@eneco/sitecore-components-content/Footer/SubFooterMenu')),
  SocialMediaMenu: dynamic(() => import('@eneco/sitecore-components-content/Footer/SocialMediaMenu')),
  TabNavigation: dynamic(() => import('@eneco/sitecore-components-content/TabNavigation/TabNavigation')),

  // Content components
  ContentCategories: dynamic(() => import('@eneco/sitecore-components-content/ContentCategories/ContentCategories')),
  ChatLinks: dynamic(() => import('@eneco/sitecore-components-content/ChatLinks/ChatLinks')),
  Accordion: dynamic(() => import('@eneco/sitecore-components-content/Accordion/Accordion')),
  Hero: dynamic(() => import('@eneco/sitecore-components-content/Hero/Hero')),
  NotificationBox: dynamic(() => import('@eneco/sitecore-components-content/NotificationBox/NotificationBox')),
  RichText: dynamic(() => import('@eneco/sitecore-components-content/RichText/RichText')),
  TopTasks: dynamic(() => import('@eneco/sitecore-components-content/TopTasks/TopTasks')),
  ContactCustomerService: dynamic(
    () => import('@eneco/sitecore-components-content/ContactCustomerService/ContactCustomerService'),
  ),
  IconList: dynamic(() => import('@eneco/sitecore-components-content/IconList/IconList')),
  Image: dynamic(() => import('@eneco/sitecore-components-content/Image/Image')),
  List: dynamic(() => import('@eneco/sitecore-components-content/List/List')),
  HeroCard: dynamic(() => import('@eneco/sitecore-components-content/HeroCard/HeroCard')),
  LinkCard: dynamic(() => import('@eneco/sitecore-components-content/LinkCard/LinkCard')),
  Price: dynamic(() => import('@eneco/sitecore-components-content/Price/Price')),
  PromoBox: dynamic(() => import('@eneco/sitecore-components-content/PromoBox/PromoBox')),
  StoreButtons: dynamic(() => import('@eneco/sitecore-components-content/StoreButtons/StoreButtons')),
  SimpleTable: dynamic(() => import('@eneco/sitecore-components-content/SimpleTable/SimpleTable')),
  TextStreamer: dynamic(() => import('@eneco/sitecore-components-content/TextStreamer/TextStreamer')),
  UsabillaFeedback: dynamic(() => import('@eneco/sitecore-components-system/UsabillaFeedback/UsabillaFeedback')),
  AddressFinder: dynamic(() => import('@eneco/sitecore-components-content/AddressFinder/AddressFinder')),
  SmeAddressFinder: dynamic(() => import('@eneco/sitecore-components-content/AddressFinder/SmeAddressFinder')),
  StepExplainer: dynamic(
    () => import('@eneco/sitecore-components-content/StepExplainerVertical/StepExplainerVertical'),
  ),
  CreditWarningBar: dynamic(() => import('@eneco/sitecore-components-content/CreditWarningBar/CreditWarningBar')),
  ShareOnSocials: dynamic(() => import('@eneco/sitecore-components-content/ShareOnSocials/ShareOnSocials')),
  ButtonLink: dynamic(() => import('@eneco/sitecore-components-content/ButtonLink/ButtonLink')),
  ButtonLineUp: dynamic(() => import('@eneco/sitecore-components-content/ButtonLineUp/ButtonLineUp')),
  FlourishChart: dynamic(() => import('@eneco/sitecore-components-content/FlourishChart/FlourishChart')),

  // Apps
  DecarbonizationPotentialBreakdown: dynamic(
    () => import('@apps/decarbonizationPotentialBreakdown-nl-eneco/DecarbonizationPotentialBreakdown'),
  ),
  CustomerReview: dynamic(() => import('@apps/customerreview-shared-multilabel/CustomerReview')),
  HeatComparisonTool: dynamic(() => import('@apps/calculator-nl-eneco/HeatComparisonCalculator')),
  InspirationAdviceFilter: dynamic(() => import('@apps/inspirationadvicefilter-nl-eneco/InspirationAdviceFilter')),

  // Other
  CookieWall: dynamic(() => import('@apps/cookiewall-nl-multilabel/CookieWall')),
  ErrorPage: dynamic(() => import('@eneco/sitecore-components-content/ErrorPage/ErrorPage')),
  GTM: dynamic(() => import('@apps/gtm-shared-multilabel')),
  MetaData: dynamic(() => import('@eneco/sitecore-components-system/MetaData/MetaData')),
  MetaTags: dynamic(() => import('@eneco/sitecore-components-system/MetaTags/MetaTags')),
  StructuredDataSchema: dynamic(
    () => import('@eneco/sitecore-components-system/StructuredDataSchema/StructuredDataSchema'),
  ),
  Chat: dynamic(() => import('@apps/chat-shared-multilabel/Chat')),

  // Wrapper components
  Article: dynamic(() => import('@eneco/sitecore-components-content/Article/Article')),
  Centered: dynamic(() => import('@eneco/sitecore-components-content/Centered/Centered')),
  Section: dynamic(() => import('@eneco/sitecore-components-content/Section/Section')),
  LineUp: dynamic(() => import('@eneco/sitecore-components-content/LineUp/LineUp')),
  NavigationView: dynamic(() => import('@eneco/sitecore-components-content/NavigationView/NavigationView')),
  SplitView: dynamic(() => import('@eneco/sitecore-components-content/SplitView/SplitView')),
  Carousel: dynamic(() => import('@eneco/sitecore-components-content/Carousel/Carousel')),
  ContentHubFilter: dynamic(() => import('@eneco/sitecore-components-content/ContentHubFilter/ContentHubFilter')),

  // Wrappable components
  ArticleCard: dynamic(() => import('@eneco/sitecore-components-content/ArticleCard/ArticleCard')),
  ArticleContentCard: dynamic(() => import('@eneco/sitecore-components-content/ArticleContentCard/ArticleContentCard')),
  ContentCard: dynamic(() => import('@eneco/sitecore-components-content/ContentCard/ContentCard')),
  ProductCard: dynamic(() => import('@eneco/sitecore-components-content/ProductCard/ProductCard')),
  StickyNav: dynamic(() => import('@eneco/sitecore-components-content/StickyNav/StickyNav')),
  Table: dynamic(() => import('@eneco/sitecore-components-content/Table/Table')),
  TitleTextCTA: dynamic(() => import('@eneco/sitecore-components-content/TitleTextCTA/TitleTextCTA')),
  PersonalizedTitleTextCTA: dynamic(
    () => import('@eneco/sitecore-components-content/PersonalizedTitleTextCTA/PersonalizedTitleTextCTA'),
  ),
  Checklist: dynamic(() => import('@eneco/sitecore-components-content/Checklist/Checklist')),
  USPItem: dynamic(() => import('@eneco/sitecore-components-content/USPItem/USPItem')),
  Video: dynamic(() => import('@eneco/sitecore-components-content/Video/Video')),

  // MeterReadings
  'meterreadings-flow': dynamic(() => import('@apps/meterreadings-nl-multilabel/MeterReadingsFlow')),
  // Decarbonization lead flow
  'decarbonization-lead-flow': dynamic(
    () => import('@apps/flows-nl-eneco-decarbonisationLeadFlow/DecarbonisationLeadFlow'),
  ),
  'b2b-lead-flow': dynamic(() => import('@apps/flows-nl-eneco-b2bLeadFlow/B2BLeadFlow')),
  // AddressFinder Example
  ExampleAddressFinderForm: dynamic(
    () => import('@eneco/sitecore-components-content/ExampleAddressFinderForm/ExampleAddressFinderForm'),
  ),

  // EnergyRating
  RegistrationAccountCreate: dynamic(
    () => import('@apps/accessmanagement-nl-multilabel/components/RegistrationFlow/RegistrationFlow'),
  ),
  RegistrationAccountReset: dynamic(
    () => import('@apps/accessmanagement-nl-multilabel/components/RegistrationFlow/RegistrationFlow'),
  ),
  RegistrationFooter: dynamic(
    () => import('@apps/accessmanagement-nl-multilabel/components/RegistrationFooter/RegistrationFooter'),
  ),
  RegistrationHeader: dynamic(
    () => import('@apps/accessmanagement-nl-multilabel/components/RegistrationHeader/RegistrationHeader'),
  ),

  // Forms
  GenericForm: dynamic(() => import('@eneco/sitecore-components/forms/GenericForm/GenericForm')),
  RevolutionForm: dynamic(() => import('@eneco/sitecore-components/forms/GenericForm/RevolutionForm')),
  GenericFormAddressField: dynamic(
    () => import('@eneco/sitecore-components/forms/GenericForm/Components/GenericFormAddress/GenericFormAddressField'),
  ),
  GenericFormNameField: dynamic(
    () => import('@eneco/sitecore-components/forms/GenericForm/Components/GenericFormNameField/GenericFormNameField'),
  ),
  GenericFormParagraph: dynamic(
    () => import('@eneco/sitecore-components/forms/GenericForm/Components/GenericFormParagraph/GenericFormParagraph'),
  ),
  GenericFormSalutationField: dynamic(
    () => import('@eneco/sitecore-components/forms/GenericForm/Components/GenericFormSalutation/GenericFormSalutation'),
  ),
  GenericFormRadioGroup: dynamic(
    () => import('@eneco/sitecore-components/forms/GenericForm/Components/GenericFormRadioGroup/GenericFormRadioGroup'),
  ),
  GenericFormCheckboxField: dynamic(
    () =>
      import('@eneco/sitecore-components/forms/GenericForm/Components/GenericFormCheckboxField/GenericFormCheckboxField'),
  ),
  GenericFormCheckboxWithValueField: dynamic(
    () =>
      import('@eneco/sitecore-components/forms/GenericForm/Components/GenericFormCheckboxWithValueField/GenericFormCheckboxWithValueField'),
  ),
  GenericFormCheckboxGroup: dynamic(
    () =>
      import('@eneco/sitecore-components/forms/GenericForm/Components/GenericFormCheckboxGroup/GenericFormCheckboxGroup'),
  ),
  GenericFormDateField: dynamic(
    () => import('@eneco/sitecore-components/forms/GenericForm/Components/GenericFormDateField/GenericFormDateField'),
  ),
  GenericFormEmailInputField: dynamic(
    () =>
      import('@eneco/sitecore-components/forms/GenericForm/Components/GenericFormEmailInputField/GenericFormEmailInputField'),
  ),
  GenericFormNumberInputField: dynamic(
    () =>
      import('@eneco/sitecore-components/forms/GenericForm/Components/GenericFormNumberInputField/GenericFormNumberInputField'),
  ),
  GenericFormPhoneNumberInputField: dynamic(
    () =>
      import('@eneco/sitecore-components/forms/GenericForm/Components/GenericFormPhoneNumberInputField/GenericFormPhoneNumberInputField'),
  ),
  GenericFormTextAreaInputField: dynamic(
    () =>
      import('@eneco/sitecore-components/forms/GenericForm/Components/GenericFormTextAreaInputField/GenericFormTextAreaInputField'),
  ),
  GenericFormInputSelect: dynamic(
    () =>
      import('@eneco/sitecore-components/forms/GenericForm/Components/GenericFormInputSelect/GenericFormInputSelect'),
  ),
  GenericFormInputField: dynamic(
    () => import('@eneco/sitecore-components/forms/GenericForm/Components/GenericFormInputField/GenericFormInputField'),
  ),
  GenericFormInputHiddenField: dynamic(
    () =>
      import('@eneco/sitecore-components/forms/GenericForm/Components/GenericFormInputHiddenField/GenericFormInputHiddenField'),
  ),
  GenericFormDivider: dynamic(
    () => import('@eneco/sitecore-components/forms/GenericForm/Components/GenericFormDivider/GenericFormDivider'),
  ),
  ContactForm: dynamic(() => import('@eneco/sitecore-components/forms/ContactForm/ContactForm')),
  RegisterToNewsletterForm: dynamic(
    () => import('@eneco/sitecore-components/forms/RegisterToNewsletterForm/RegisterToNewsletterForm'),
  ),
  RevolutionRegisterToNewsletterForm: dynamic(
    () => import('@eneco/sitecore-components/forms/RegisterToNewsletterForm/RevolutionRegisterToNewsletterForm'),
  ),
  NewsletterFormIntegratedWithRevolution: dynamic(
    () =>
      import('@eneco/sitecore-components/forms/NewsletterFormIntegrateWithRevolutionCRM/NewsletterFormIntegrateWithRevolutionCRM'),
  ),
  EmailRequestWrapper: dynamic(
    () => import('@eneco/sitecore-components/forms/EmailRequestWrapper/EmailRequestWrapper'),
  ),
  ContentCardRebranded: dynamic(
    () => import('@eneco/sitecore-components-content/ContentCardRebranded/ContentCardRebranded'),
  ),
  HeroRebranded: dynamic(() => import('@eneco/sitecore-components-content/HeroRebranded/HeroRebranded')),
  HeroCardRebranded: dynamic(() => import('@eneco/sitecore-components-content/HeroCardRebranded/HeroCardRebranded')),
  TextImageRebranded: dynamic(() => import('@eneco/sitecore-components-content/TextImageRebranded/TextImageRebranded')),
  FeaturePreview: dynamic(() => import('@eneco/sitecore-components-content/FeaturePreview/FeaturePreview')),
};
